var Advice;
(function (Advice) {
    myonce('advice', () => {
        let $advices = document.querySelectorAll('[data-advice]');
        if ($advices.length) {
            localforage.getItem('advice-catalog').then(skipped => {
                if (skipped && skipped.length) {
                    skipped.forEach(id => {
                        id &&
                            document
                                .querySelectorAll(`[data-advice='${id}']`)
                                .forEach($advice => $advice.remove());
                    });
                }
            }).finally(() => {
                $advices = document.querySelectorAll('[data-advice]');
                $advices.forEach($advice => {
                    $advice.classList.add('is-active');
                    const urlAdvice = $advice.querySelector('.link > a').getAttribute('href');
                    const pageUrl = location.pathname;
                    if (urlAdvice && urlAdvice === pageUrl) {
                        $advice.remove();
                    }
                    $advice
                        .querySelector('[data-close-advice]')
                        .addEventListener('click', () => {
                        const id = $advice.getAttribute('data-advice');
                        $advice.remove();
                        if (id) {
                            localforage
                                .getItem('advice-catalog')
                                .then(skipped => {
                                skipped = skipped || [];
                                skipped.push(id);
                                localforage.setItem('advice-catalog', skipped);
                            });
                        }
                    });
                });
            });
        }
    });
})(Advice || (Advice = {}));
